import { useQuery } from 'react-query';
import { getCatalogAdditionalAttributes } from 'services/assetconfig';
import { getAssetAdditionalAttributes } from 'services/assets';
import { getFinAssetAdditionalAttributes } from 'services/finassets';
import { getThirdPartyAdditionalAttributes } from 'services/thirdParty';

export function useAttributeContextFramework(
  entity?: string,
  object?: string,
  //   entityid?: number;
  entitytype?: string,
  prcode?: string,
  assetfamily?: string,
  assettype?: string,
  assetcategory?: string,
  assetsegment?: string,
  assetmodel?: string
) {

  const catalogQuery: {
    data: any;
    refetch: any;
    isFetching: any;
    isError: any;
  } = useQuery(
    [
      'getCatalogAdditionalAttributes',
      {
        assetcategory: assetcategory ?? '',
        assetfamily: assetfamily ?? '',
        assettype: assettype ?? '',
        assetsegment: assetsegment ?? '',
        assetmodel: assetmodel ?? '',
        entity: entity ?? '',
        entityid: 0,
        entitytype: entitytype,
        prcode: '',
      },
    ],
    async () =>
      await getCatalogAdditionalAttributes({
        assetcategory: assetcategory ?? '',
        assetfamily: assetfamily ?? '',
        assettype: assettype ?? '',
        assetsegment: assetsegment ?? '',
        assetmodel: assetmodel ?? '',
        entity: entity ?? '',
        entityid: 0,
        entitytype: entitytype ?? '',
        prcode: '',
      }).then((res: any) => {
        return res.list || [];
      }),
    { enabled: object === 'CATALOG' }
  );

  const assetQuery: { data: any; refetch: any; isFetching: any; isError: any } =
    useQuery(
      [
        'getAssetAdditionalAttributes',
        {
          assetcategory: assetcategory ?? '',
          assetfamily: assetfamily ?? '',
          assettype: assettype ?? '',
          assetsegment: assetsegment ?? '',
          assetmodel: assetmodel ?? '',
          entity: entity ?? '',
          entityid: 0,
          entitytype: entitytype,
          prcode: '',
        },
      ],
      async () =>
        await getAssetAdditionalAttributes({
          assetcategory: assetcategory ?? '',
          assetfamily: assetfamily ?? '',
          assettype: assettype ?? '',
          assetsegment: assetsegment ?? '',
          assetmodel: assetmodel ?? '',
          entity: entity ?? '',
          entityid: 0,
          entitytype: entitytype ?? '',
          prcode: '',
        }).then((res: any) => {
          return res.list || [];
        }),
      { enabled: object === 'ASSET' }
    );

  const thirdPartyQuery: {
    data: any;
    refetch: any;
    isFetching: any;
    isError: any;
  } = useQuery(
    [
      'getThirdPartyAdditionalAttributes',
      {
        assetcategory: '',
        assetfamily: '',
        assettype: '',
        assetsegment: '',
        assetmodel: '',
        entity: entity ?? '',
        entityid: 0,
        entitytype: entitytype,
        prcode: '',
      },
    ],
    async () =>
      await getThirdPartyAdditionalAttributes({
        assetcategory: '',
        assetfamily: '',
        assettype: '',
        assetsegment: '',
        assetmodel: '',
        entity: entity ?? '',
        entityid: 0,
        entitytype: entitytype ?? '',
        prcode: '',
      }).then((res: any) => {
        return res.list || [];
      }),
    { enabled: object === 'THIRDPARTY' }
  );

  const finAssetQuery: {
    data: any;
    refetch: any;
    isFetching: any;
    isError: any;
  } = useQuery(
    [
      'getFinAssetAdditionalAttributes',
      {
        assetcategory: assetcategory ?? '',
        assetfamily: assetfamily ?? '',
        assettype: assettype ?? '',
        assetsegment: assetsegment ?? '',
        assetmodel: assetmodel ?? '',
        entity: entity ?? '',
        entityid: 0,
        entitytype: entitytype,
        prcode: '',
      },
    ],
    async () =>
      await getFinAssetAdditionalAttributes({
        assetcategory: assetcategory ?? '',
        assetfamily: assetfamily ?? '',
        assettype: assettype ?? '',
        assetsegment: assetsegment ?? '',
        assetmodel: assetmodel ?? '',
        entity: entity ?? '',
        entityid: 0,
        entitytype: entitytype ?? '',
        prcode: '',
      }).then((res: any) => {
        return res.list || [];
      }),
    { enabled: object === 'FINASSET' }
  );

  switch (object) {
    case 'ASSET':
      return assetQuery;
    case 'FINASSET':
      return finAssetQuery;
    case 'CATALOG':
      return catalogQuery;
    case 'THIRDPARTY':
      return thirdPartyQuery;
    default:
      return assetQuery;
  }
}
